import { Button } from 'antd'
import clsx from 'clsx'
import { useMemo, type Dispatch, type SetStateAction } from 'react'
import { useAccount } from 'wagmi'

import { useLocalStorage } from '@/context/localstorage-context'
import type { OpenStoremanStakeInTransParamsInterface } from '@/types/trans-params'
import { hexCharCodeToStr } from '@/utils'

export default function StepTwo_2({
  isPending,
  setStep,
  tarnsParam,
  handleSendTrans,
}: {
  isPending: boolean
  tarnsParam: OpenStoremanStakeInTransParamsInterface
  setStep: Dispatch<SetStateAction<number>>
  handleSendTrans: () => void
}) {
  const { address } = useAccount()
  const { theme } = useLocalStorage()
  const isDark = useMemo(() => theme === 'dark', [theme])

  return (
    <div>
      <div className="">
        <p className="text-3xl text-light-111 mb-[10px] dark:text-dark-111">
          Confirmation
        </p>
      </div>
      <div className="border-1 border-light-555 rounded-2xl mt-[10px] p-[10px] dark:border-dark-666 dark:text-dark-0">
        <span className="dark:text-white">My Bridge Node Account</span>
        <div className="mt-[10px] text-[12px]">
          <div className="flex justify-between border-1 border-light-555 rounded-2xl w-full p-5 gap-5 overflow-hidden dark:border-dark-666">
            <div className="whitespace-nowrap text-light-444">Group ID</div>
            <div className="flex-1 break-words text-right max-w-[80%]">
              {hexCharCodeToStr(tarnsParam.groupId)}
            </div>
          </div>
          <div className="flex justify-between border-1 border-light-555 rounded-2xl w-full p-5 gap-5 overflow-hidden mt-3 dark:border-dark-666 dark:text-dark-0">
            <div className="whitespace-nowrap text-light-444">Public Key</div>
            <div className="flex-1 break-words text-right max-w-[80%]">
              {tarnsParam.PK}
            </div>
          </div>
          <div className="flex justify-between border-1 border-light-555 rounded-2xl w-full p-5 gap-5 overflow-hidden mt-3 dark:border-dark-666 dark:text-dark-0">
            <div className="whitespace-nowrap text-light-444">Enode ID</div>
            <div className="flex-1 break-words text-right max-w-[80%]">
              {tarnsParam.enodeID}
            </div>
          </div>
        </div>
      </div>
      <div className="border-1 border-light-555 rounded-2xl mt-[10px] p-[10px] dark:border-dark-666 dark:text-dark-0">
        <div className="dark:text-white">My Wallet Account</div>
        <div className="mt-[10px] text-[12px]">
          <div className="flex justify-between border-1 border-light-555 rounded-2xl w-full p-5 gap-5 overflow-hidden dark:border-dark-666 dark:text-dark-0">
            <div className="whitespace-nowrap text-light-444">Address</div>
            <div className="flex-1 break-words text-right max-w-[80%]">
              {address}
            </div>
          </div>
          <div className="flex justify-between border-1 border-light-555 rounded-2xl w-full p-5 gap-5 overflow-hidden mt-3 dark:border-dark-666 dark:text-dark-0">
            <div className="whitespace-nowrap text-light-444">Amount</div>
            <div className="flex-1 break-words text-right max-w-[80%]">
              {tarnsParam.amount} WAN
            </div>
          </div>
        </div>
      </div>
      <div
        className={clsx('w-full flex justify-around mt-[20px]', {
          'btn1-light': !isDark,
          'btn1-dark': isDark,
        })}
      >
        <Button
          onClick={() => setStep(11)}
          className="w-[47%] rounded-2xl h-[60px] text-[18px]"
        >
          Previous
        </Button>
        <Button
          loading={isPending}
          className="w-[47%] rounded-2xl h-[60px] btn text-[18px]"
          onClick={handleSendTrans}
        >
          Next
        </Button>
      </div>
    </div>
  )
}
